<template>
  <div
    v-if="transactions && transactions.length"
    class="transaction-history">
    <h5>Billing History</h5>
    <div>
      <el-row class="header">
        <el-col :span="7">
          Payment method
        </el-col>
        <el-col :span="7">
          Amount
        </el-col>
        <el-col :span="7">
          Billing date
        </el-col>
      </el-row>
      <el-row
        v-for="(transaction, index) of transactions"
        :key="index"
        type="flex"
        justify="space-between"
        align="middle"
        class="item">
        <el-col :span="10">
          <div class="d-flex flex-middle-align">
            <span class="card-type">
              <img
                v-if="transaction.card_type === 'visa'"
                src="../../assets/images/visa.png"
              >
              <img
                v-if="transaction.card_type === 'mc'"
                src="../../assets/images/mastercard.png"
              >
              <img
                v-if="transaction.card_type === 'amex'"
                src="../../assets/images/amex.png"
              >
              <img
                v-if="transaction.card_type === 'discover'"
                src="../../assets/images/discover_card.png"
              >
            </span>
            <span>
              <span class="muted">ending in </span>{{ transaction.last_four_numbers }}
            </span>
          </div>
        </el-col>
        <el-col :span="7">
          {{ transaction.price || 0 | amountFilter }}
        </el-col>
        <el-col :span="7">
          {{ transaction.updated_at | dateFormat }}
        </el-col>
        <el-col
          :span="3"
          class="t-r cursor-pointer">
          <el-dropdown
            v-if="transaction.zuora_invoice_id"
            :trigger="isTouchDevice ? 'click' : 'hover'"
          >
            <span class="el-dropdown-link">
              <img :src="moreIcon">
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openModel(transaction.uuid)">View invoice</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </div>
    <price-breakdown-modal
      :show_modal="showPriceBreakDownModal"
      :invoice_id="selectedInvoiceId"
      @close="closeModel"/>
  </div>
</template>
<script>
import moreIcon from '../../assets/images/ic_More.svg';
import PriceBreakdownModal from './PricebreakdownModal';
import Subscription from '../../services/Subscription';

export default {
  components: {
    'price-breakdown-modal': PriceBreakdownModal,
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      transactions: [],
      moreIcon,
      showPriceBreakDownModal: false,
      subscriptionProvider: new Subscription(),
      selectedInvoiceId: '',
    };
  },
  computed: {
    isTouchDevice() {
      return window.isTouch;
    },
  },
  watch: {
    count(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchTransactionHistory();
      }
    },
  },
  mounted() {
    this.fetchTransactionHistory();
  },
  methods: {
    openModel(zuoraInvoiceId) {
      this.showPriceBreakDownModal = true;
      this.selectedInvoiceId = zuoraInvoiceId;
    },
    closeModel() {
      this.showPriceBreakDownModal = false;
    },
    fetchTransactionHistory() {
      const params = {
        txn_type: 'payment',
      };
      this.subscriptionProvider.fetchTransactionHistory(params).then((resp) => {
        this.transactions = resp || [];
      });
    },
  },
};
</script>
<style lang="scss">
.transaction-history{
  margin-top: 70px;
  .header{
    color: #666666;
    font-size: 14px;
    border-bottom: 1px solid #BABABA;
    div {
      margin-bottom: 8px;
    }
  }
  .card-type {
    width: 36px;
    height: 24px;
    margin-right: 12px;

    img {
      height: 100%;
      width: 100%;
    }
  }
  .item{
    padding: 24px 0;
    border-bottom: 1px solid #BABABA;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/TransactionHistory.vue